import { getQueryStringParamsFromStringUrl, logger } from '$utils'
import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import { getDateRangeFromQueryStringOrAppStore } from 'src/components/common/helpers/queryString'
import useStockStore from '../../../store'

export default async function loader({ request }) {
  const queryParams = getQueryStringParamsFromStringUrl(request.url)

  logger.debug(
    '[loader] About to await AppState being ready in Accounting System Export loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Accounting System Export loader'
  )
  const { startDateTime, endDateTime } =
    getDateRangeFromQueryStringOrAppStore(queryParams)

  const getSupplierStatements = useStockStore
    .getState()
    .getSupplierStatements(startDateTime, endDateTime, undefined, false)

  const getStockReceivedItems = useStockStore
    .getState()
    .getStockReceivedItems(startDateTime, endDateTime, undefined, false)

  const setExportType = useStockStore.getState().setExportType('orders')

  return defer({
    data: Promise.all([
      getSupplierStatements,
      getStockReceivedItems,
      setExportType,
    ])
      .then(() => true)
      .catch((error) => {
        logger.error('Accounting System Export Promise.all error', error)
        return false
      }),
  })
}
